import { lazy } from 'react';

/**
 * Centralização de todos os lazy imports da aplicação.
 *
 * Mantemos tanto páginas quanto componentes preguiçosamente carregados aqui
 * para evitar duplicação e garantir um único ponto de manutenção.
 */
export const lazyPages = {
  ResetPassword: lazy(() => import('@pages/ResetPassword')),
  // Página de demandas: sem alias @features configurado (só @pages/@components), então
  // import relativo mesmo — é a única página do app que ainda carregava no bundle principal.
  DemandsBoard: lazy(() => import('../features/demands/DemandsBoard')),
  // Páginas
  ClientManagement: lazy(() => import('@pages/ClientManagement')),
  PublicDemandForm: lazy(() => import('@pages/PublicDemandForm')),
  PublicSuggestionForm: lazy(() => import('@pages/PublicSuggestionForm')),
  PublicOperationReport: lazy(() => import('@pages/PublicOperationReport')),
  ProviderCompletionLinkPage: lazy(() => import('@pages/ProviderCompletionLinkPage')),
  ConfigPage: lazy(() => import('@pages/ConfigPage')),
  UserManagement: lazy(() => import('@pages/UserManagement')),
  RoleManagement: lazy(() => import('@pages/RoleManagement')),
  Profile: lazy(() => import('@pages/Profile')),
  ReportsPage: lazy(() => import('@pages/ReportsPage')),
  ProviderManagement: lazy(() => import('@pages/ProviderManagement')),
  ChecklistManagement: lazy(() => import('@pages/ChecklistManagement')),
  PatrimonyManagement: lazy(() => import('@pages/PatrimonyManagement')),
  PatrimonyConference: lazy(() => import('@pages/PatrimonyConference')),
  QrCodesManagement: lazy(() => import('@pages/QrCodesManagement')),
  RecurringDemandsManagement: lazy(() => import('@pages/RecurringDemandsManagement')),
  PublicPanelManagement: lazy(() => import('@pages/PublicPanelManagement')),
  ResourceCenterPage: lazy(() => import('@pages/ResourceCenterPage')),
  FinancePage: lazy(() => import('@pages/FinancePage')),
  SystemAdminSelection: lazy(() => import('@pages/SystemAdminSelection')),
  PlatformAuditPage: lazy(() => import('@pages/PlatformAuditPage')),
  UnderConstruction: lazy(() => import('@pages/UnderConstruction')),
  NotFound: lazy(() => import('@pages/NotFound')),

  // Componentes de configuração
  EmailConfig: lazy(() => import('@components/config/EmailConfig')),
} as const;


